module.exports = __webpack_public_path__ + "static/media/green-button-landing.93deff84.png";